import { findSelectedFee } from 'clientState/priceHelper';
import legResolver from './leg';
import { FeeType, ItineraryFragment } from 'generated/graphql';

export type ResolvedItinerary = ReturnType<typeof itineraryResolver>;

export default function itineraryResolver(
  itinerary: ItineraryFragment,
  index: number,
  extensions?: Extensions | null
) {
  const legs = itinerary.legs?.map(legResolver);
  return {
    ...itinerary,
    priceSortingPosition: index + 1,
    legs,
    duration: durationResolver(legs),
    hasCheckInBaggage: hasCheckInBaggageResolver(legs),
    debugInfo: debugInfoResolver(itinerary, extensions),
  };
}

export function externalSelectionResolver(
  itinerary: ItineraryFragment,
  index: number,
  extensions?: Extensions | null,
  defaultFeeType?: FeeType | null
) {
  const fee = findSelectedFee(itinerary, defaultFeeType);
  return {
    ...itineraryResolver(itinerary, index, extensions),
    highlightedType: 'metaSelection',
    price: fee?.price,
  };
}
export type Extensions = {
  debugInfo: {
    qamode: {
      'search-engine': {
        [key: string]: string;
      };
      'me-rating': {
        [key: string]: string;
      };
    };
  };
};
function isExtension(
  extensions?: Extensions | null
): extensions is Required<Extensions> {
  return (
    !!extensions &&
    'debugInfo' in extensions &&
    typeof extensions?.debugInfo === 'object' &&
    !!extensions?.debugInfo &&
    'qamode' in extensions.debugInfo &&
    extensions?.debugInfo?.qamode !== undefined &&
    typeof extensions?.debugInfo?.qamode === 'object'
  );
}
const debugInfoResolver = (
  itinerary: ItineraryFragment,
  extensions?: Extensions | null
) => {
  if (!isExtension(extensions)) {
    return;
  }
  const qamode = extensions?.debugInfo?.qamode;
  if (!qamode['me-rating']) {
    return qamode['search-engine'][itinerary.key];
  }
  return (
    qamode['search-engine'][itinerary.key] +
    'me-rating: ' +
    qamode['me-rating'][itinerary.id]
  );
};

function durationResolver(legs) {
  let total = 0;
  legs.forEach((leg) => (total += leg.segments[0].duration));
  return total;
}

function hasCheckInBaggageResolver(legs) {
  return legs.every(({ segments }) => {
    return segments.every(
      ({ baggageCondition }) => baggageCondition === 'CHECKIN_INCLUDED'
    );
  });
}
